import {
  Eye, ShieldCheck, ChartLineUp, Path, Headset, LockKey,
} from "@phosphor-icons/react";
import { Chapter, Reveal } from "./Reveal";

const FEATURES = [
  { icon: Eye, title: "Transparent Process", text: "Clear transaction details and status visibility at every stage." },
  { icon: ShieldCheck, title: "Verification-Based Transactions", text: "Transactions are processed only after the required verification checks." },
  { icon: ChartLineUp, title: "Competitive Rates", text: "Indicative market rates that track real market conditions." },
  { icon: Path, title: "Transaction Tracking", text: "Follow every transaction from submission to completion." },
  { icon: Headset, title: "Dedicated Support", text: "Reach the team directly inside the app whenever you need help." },
  { icon: LockKey, title: "Security-Focused Infrastructure", text: "Authenticated sessions and careful handling across the platform." },
];

export default function WhyRupora() {
  return (
    <section id="why" className="border-y border-line/70 bg-pine/40" data-testid="features-section">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
        <Chapter index="05" label="Why Rupora" />
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-xl font-display text-4xl font-semibold tracking-tighter text-paper sm:text-5xl">
              Why <span className="text-brand-400">Rupora?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-md text-base leading-relaxed text-mist">
              Built around verification, transparency and tracking — not promises.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={0.05 + (i % 3) * 0.06} className="h-full">
              <div
                className="group flex h-full flex-col rounded-3xl border border-line bg-night p-8 transition-all duration-500 hover:-translate-y-1 hover:border-brand-500/40 hover:shadow-xl hover:shadow-brand-500/10"
                data-testid={`feature-card-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <div className="mb-6 inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-500/12 text-brand-400 transition-colors duration-500 group-hover:bg-brand-500 group-hover:text-white">
                  <f.icon size={24} weight="duotone" />
                </div>
                <h3 className="font-display text-lg font-semibold tracking-tight text-paper sm:text-xl">{f.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-mist">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
